import React from "react";
import { MemberPasswordChangeComponent } from "./MemberPasswordChangeComponent";
import { MemberProfileImageUploadComponent } from "./MemberProfileImageUploadComponent";
import { MemberProfilePropertyEditorComponent } from "./MemberProfilePropertyEditorComponent";
import { NotificationPreferencesComponent } from "./NotificationPreferencesComponent";
import FetchHelper from "./lib/fetchHelper.js";
import { ProfileAvatar } from "./lib/profileAvatar";
import { ReactRenderer } from "./lib/ReactRenderer";
/**
 * Min side (the boards "Min side"): on a phone the member's name with the avatar, the shortcuts to the
 * member's own pages, the four cards and Log ud in one column; from lg the title, with the three cards
 * about the member in the left column and the shortcuts, the notifications and Log ud in the right.
 * The slots are in the order of the phone, and the stylesheet puts the columns around them.
 */
export class MemberProfileFormComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount() {
        FetchHelper.get("/bpapi/memberprofile/profileimage")
            .then((image) => this.setState({ image }))
            .catch(() => undefined);
    }
    // Log ud is a form of the server (it needs the anti-forgery token); the view renders it out of sight.
    logOut() {
        var _a;
        (_a = document.getElementById("bi-pf-logout")) === null || _a === void 0 ? void 0 : _a.requestSubmit();
    }
    render() {
        const { name, initials, shortcuts } = this.props;
        return (React.createElement("div", { className: "bi-pf" },
            React.createElement("div", { className: "bi-pf-head d-lg-none" },
                React.createElement(ProfileAvatar, { image: this.state.image, initials: initials }),
                React.createElement("div", null,
                    React.createElement("h1", null, name),
                    React.createElement("p", null, "Frivillig"))),
            React.createElement("h1", { className: "bi-pf-title d-none d-lg-block" }, "Min side"),
            React.createElement("div", { className: "bi-pf-cols" },
                React.createElement("div", { className: "bi-pf-col" },
                    React.createElement("div", { className: "bi-pf-slot bi-pf-slot-info" },
                        React.createElement(MemberProfilePropertyEditorComponent, null)),
                    React.createElement("div", { className: "bi-pf-slot bi-pf-slot-image" },
                        React.createElement(MemberProfileImageUploadComponent, { image: this.state.image, initials: initials, onImage: (image) => this.setState({ image }) })),
                    React.createElement("div", { className: "bi-pf-slot bi-pf-slot-password" },
                        React.createElement(MemberPasswordChangeComponent, null))),
                React.createElement("div", { className: "bi-pf-col" },
                    shortcuts.length > 0 &&
                        React.createElement("nav", { className: "bi-pf-slot bi-pf-slot-shortcuts bi-card bi-list", "aria-label": "Mine sider" }, shortcuts.map((shortcut) => (React.createElement("a", { key: shortcut.url, className: "bi-row", href: shortcut.url },
                            React.createElement("span", { className: "bi-row-title" }, shortcut.title),
                            React.createElement("svg", { className: "bi-menu-chevron", width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" },
                                React.createElement("path", { d: "m9 6 6 6-6 6" })))))),
                    React.createElement("div", { className: "bi-pf-slot bi-pf-slot-notifications" },
                        React.createElement(NotificationPreferencesComponent, null)),
                    React.createElement("button", { type: "button", className: "bi-pf-slot bi-pf-slot-logout bi-btn bi-btn-outline", onClick: () => this.logOut() },
                        React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" },
                            React.createElement("path", { d: "M10 4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5M15 8l4 4-4 4M19 12H9" })),
                        "Log ud")))));
    }
}
ReactRenderer.render("memberprofileformcomponent", (elem) => {
    var _a, _b, _c;
    return React.createElement(MemberProfileFormComponent, { name: (_a = elem.dataset.name) !== null && _a !== void 0 ? _a : "", initials: (_b = elem.dataset.initials) !== null && _b !== void 0 ? _b : "", shortcuts: JSON.parse((_c = elem.dataset.shortcuts) !== null && _c !== void 0 ? _c : "[]") });
});
